import React, { useEffect, useState } from "react";
import { Autocomplete, useModulesManager, useTranslations } from "@openimis/fe-core";
import { useContributionPlanQuery } from "../hooks";
import _debounce from "lodash/debounce";

const PolicyContributionPlanPicker = (props) => {
  const {
    multiple,
    required,
    placeholder,
    label,
    withLabel,
    withPlaceholder,
    readOnly,
    value,
    onChange,
    filter,
    filterSelectedOptions,
    locationId,
    family_uuid,
  } = props;
  const modulesManager = useModulesManager();
  const [filters, setFilters] = useState({  applyDefaultValidityFilter: true});
  const { formatMessage } = useTranslations("policy", modulesManager);
  const { isLoading, error, data } = useContributionPlanQuery({ filters }, { skip: true },family_uuid);

  const onOpen = () => {
    setFilters({ first: 15, applyDefaultValidityFilter: true  });
  };
  return (
    <Autocomplete
      multiple={multiple}
      required={required}
      error={error}
      placeholder={placeholder ?? formatMessage("ProductPicker.placeholder")}
      label={label ?? formatMessage("ContributionPlan")}
      withLabel={withLabel}
      withPlaceholder={withPlaceholder}
      readOnly={readOnly}
      options={ !!data.contributionPlan ? data.contributionPlan : [] }
      isLoading={isLoading}
      value={value}
      getOptionLabel={(option) => `${option.code} ${option.name}`}
      onChange={(value) => onChange(value, value ? `${value.code} ${value.name}` : null)}
      onOpen={onOpen}
      filterOptions={filter}
      filterSelectedOptions={filterSelectedOptions}
      onInputChange={(search) => setFilters({ first: 15, search, applyDefaultValidityFilter: true, isDeleted: false })}
    />
  );
};

export default PolicyContributionPlanPicker;
